import React from 'react';
import PropTypes from 'prop-types';
import CurrentUserMapWithLegend from '../../../containers/FacilitiesNearbyCurrentUserMapWithLegend';
import FacilityMapWithLegend from '../../../containers/FacilitiesNearbyFacilityMapWithLegend';
import {
  OPTION_NEAR_FACILITY,
  OPTION_NEAR_CURRENT_USER,
  OPTION_DEFAULT,
  FACILITY_DIST,
  HEADER_TEXT,
} from './properties';

const propTypes = {
  center: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }),
  facilityDistance: PropTypes.number,
  headerText: PropTypes.string,
  pageFacilityId: PropTypes.string,
  selectedFacilityId: PropTypes.string,
  selectedOption: PropTypes.string,
  zoom: PropTypes.number,
};

const defaultProps = {
  center: undefined,
  facilityDistance: FACILITY_DIST,
  headerText: HEADER_TEXT,
  pageFacilityId: undefined,
  selectedFacilityId: undefined,
  selectedOption: OPTION_DEFAULT,
  zoom: undefined,
};

const NearbyLocations = ({
  headerText,
  selectedOption,
  facilityDistance,
  selectedFacilityId,
  pageFacilityId,
  center,
  zoom,
}) => {
  // If `center` or `zoom` are `null`, we want to pass `undefined` to our
  // components instead. `null` is meant to represent the intentional absence of
  // a value and `undefined` is meant to represent a variable that has not been
  // assigned a value. We are using both interchangeably, which causes confusion
  // in our components.
  const initialCenter = center || undefined;
  const initialZoom = zoom || undefined;

  if (selectedOption === OPTION_NEAR_CURRENT_USER) {
    // SSR is disabled for this option because the results for the query would
    // otherwise be cached during warming. That means the "current user" in this
    // context would always be the instance that warmed the cache and not the user
    // actually requesting the page.
    return (
      <CurrentUserMapWithLegend
        primaryFacilityId={pageFacilityId}
        ssr={false}
        title={headerText}
      />
    );
  }

  if (selectedOption === OPTION_NEAR_FACILITY) {
    return (
      <FacilityMapWithLegend
        facilityId={selectedFacilityId}
        initialCenter={initialCenter}
        initialZoom={initialZoom}
        maxDistanceInMiles={parseInt(facilityDistance, 10)}
        primaryFacilityId={pageFacilityId}
        title={headerText}
      />
    );
  }

  return null;
};

NearbyLocations.propTypes = propTypes;
NearbyLocations.defaultProps = defaultProps;

export default NearbyLocations;
